import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IBranchPromiseLookupService } from "../IBranchPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export abstract class BranchPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.BranchImpl>
  implements IBranchPromiseLookupService
{
  constructor() {
    super();
  }
  abstract getBranch(id: string): Promise<CubiqTS.BranchImpl>;
  abstract getAllBranchCodes(): Promise<Array<string>>;
  abstract getCompleteListOfBranchCodes(): Promise<Array<string>>;
}
